<div class="h-100 d-flex flex-column">
	<div class="pep-container">
		<h5>Declaración Jurada PEP</h5>
		<h6>Persona Expuesta Políticamente</h6>
		<p class="subtitle-resolution">Resolución UIF N° 35/2023 y N° 192/2024</p>
		
		<div class="pep-definition">
			<p class="pep-text">{{ PEP_TEXT }}</p>
		</div>

		<form [formGroup]="pepForm" class="pep-form">
			<div class="form-group">
				<label>¿Es usted Persona Expuesta Políticamente?</label>
				<div class="radio-group">
					<label class="radio-label">
						<input type="radio" formControlName="is_pep" [value]="false" (change)="onIsPepChange()"> No
					</label>
					<label class="radio-label">
						<input type="radio" formControlName="is_pep" [value]="true" (change)="onIsPepChange()"> Sí
					</label>
				</div>
			</div>

			<div *ngIf="isPep" class="pep-details">
				<div class="form-group">
					<label>Cargo / Función *</label>
					<input type="text" class="form-control" formControlName="cargo_funcion" placeholder="Ej: Diputado Nacional">
				</div>
				
				<div class="form-group">
					<label>Organismo / Entidad *</label>
					<input type="text" class="form-control" formControlName="organismo_entidad" placeholder="Ej: Congreso de la Nación">
				</div>
				
				<div class="form-group">
					<label>Fecha inicio actividad *</label>
					<input type="date" class="form-control" formControlName="periodo_desde" [max]="today">
				</div>
				
				<div class="form-group">
					<label>Relación (si es familiar o allegado)</label>
					<input type="text" class="form-control" formControlName="relacion" placeholder="Ej: Cónyuge, Hijo/a, Socio comercial">
				</div>
			</div>
		</form>

		<div class="pep-notice">
			<small>El Cliente se obliga a informar cualquier cambio en la información declarada durante la vigencia de la relación contractual.</small>
		</div>
	</div>

	<div class="credilow-footer credilow-navigate mt-auto mb-3">
		<button
			class="credilow-next-button credilow-shadow"
			[ngClass]="{sanii: !useCredilowStyle}"
			[disabled]="pepForm.invalid"
			(click)="submitPep()"
			appEnterClick
		>
			Confirmar Declaración
		</button>
	</div>
</div>
<app-loader *ngIf="loading | async"></app-loader>
